import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sparkles, ArrowRight, X } from 'lucide-react';

const HIDE_PREFIXES = ['/davet-evi-sahipleri', '/mekan-basvuru', '/isortagi-basvuru', '/admin', '/dashboard', '/giris', '/login', '/mekan-giris', '/nisan-hediyelikleri', '/register', '/kayit'];

const OwnerBanner = () => {
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem('ownerBannerDismissed') === '1');
  if (hidden || HIDE_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    sessionStorage.setItem('ownerBannerDismissed', '1');
    setHidden(true);
  };

  return (
    <div className="fixed top-[72px] right-2 sm:right-4 z-40 animate-in slide-in-from-right-4 fade-in duration-500" data-testid="owner-banner">
      <Link
        to="/davet-evi-sahipleri"
        className="group relative flex items-center gap-2 rounded-full bg-neutral-950 text-white pl-3 pr-8 py-2 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.5)] ring-1 ring-white/10 hover:bg-rose-700 transition-colors"
        data-testid="owner-banner-link"
      >
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-rose-400" />
        </span>
        <Sparkles className="w-3.5 h-3.5 text-amber-300 hidden sm:block" />
        <span className="text-[12px] sm:text-[13px] font-semibold tracking-tight">
          <span className="sm:hidden">Mekan sahibi misiniz?</span>
          <span className="hidden sm:inline">Davet evi sahibi misiniz?</span>
        </span>
        <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
        <button type="button" onClick={dismiss} aria-label="Kapat" className="absolute right-1.5 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-white/10 hover:bg-white/25 flex items-center justify-center" data-testid="owner-banner-close">
          <X className="w-3 h-3" />
        </button>
      </Link>
    </div>
  );
};

export default OwnerBanner;
